module.exports = __webpack_public_path__ + "3fe3f7fb4ae4bf93a326972740a2d9bf.pdf";